import { useContext } from "react";
import { ThemeOverrideWrapper } from "../../components/layout/themes";
import { ThemeContext } from "../../components/layout/ThemeContext";
import { useSelector } from "react-redux";
import { AppState } from "../types";
import { getDarkMapStyles } from "../../components/locations/getDarkMapStyles";
import { Theme, useTheme } from "@material-ui/core";

export const useProLogsMapTheme = () => {
  const brandTheme = useContext<ThemeOverrideWrapper>(ThemeContext);
  const type = useSelector((state: AppState) => state.theme);
  const theme = useTheme<Theme>();
  return type === "dark"
    ? brandTheme.dark?.googleMap ?? getDarkMapStyles(theme)
    : brandTheme.light?.googleMap;
};
